<template>
    <div>
        <app-title text="PQR's Sin Asignar" />
        <b-card
            title="Crear PQR"
            header-tag="header"
            footer-tag="footer"
            style="max-width: 24rem;"
        >
            <div
                class="card-text d-flex align-items-end justify-content-around"
            >
                <div class="client-selector-section">
                    <app-form-select-input
                        label="Seleccione cliente"
                        :options="clients"
                        v-model="clientId"
                    />
                </div>
                <div class="button-section">
                    <b-button
                        variant="primary"
                        :disabled="!clientId"
                        @click="$bus.$emit('petition-form.open')"
                        >Crear PQR</b-button
                    >
                </div>
            </div>
        </b-card>
        <br />
        <app-petition-filters @filter="onFilter" :isNotAssigned="true" />
        <app-table-unassigned-petitions
            :data="data"
            :on-change-page="onChangePage"
            :see-comments-by-petition="seeCommentsByPetition"
            :see-more="seeMore"
            :start-add-comment="startAddComment"
            :start-assign-user-to-petition="startAssignUserToPetition"
            :delete-petition="deletePetition"
            @sort="onSort"
        />

        <!-- inicio de pop ups -->

        <app-pop-up
            title="Formulario de petición"
            id="petition-form"
            :onClose="cleanPqrForm"
        >
            <div class="body" slot="body">
                <app-pqr-form
                    :on-save="onSave"
                    :client-selected="clientId"
                    :is-director="true"
                ></app-pqr-form>
            </div>
            <div slot="buttons">
                <button
                    class="btn btn-confirm"
                    :disabled="inProgress"
                    @click="$bus.$emit('petition-form.save')"
                >
                    Guardar
                </button>
            </div>
        </app-pop-up>

        <app-pop-up
            title="Comentarios de la petición"
            size="large"
            id="view-comments-petition-unassigned"
        >
            <div class="body" slot="body">
                <app-petition-comments-list
                    :onRemove="onRemoveComment"
                    :comments="commentsPetitionSelect"
                />
            </div>
        </app-pop-up>

        <app-pop-up
            title="Agregar comentario a la petición"
            id="petition-comment-unassigned"
            :onClose="cleanFormComment"
        >
            <div class="body" slot="body">
                <app-add-petition-comment
                    id="petition-comment-unassigned"
                    :petition="petitionComment"
                    :on-save="onSaveComment"
                />
            </div>
            <div slot="buttons">
                <button
                    class="btn btn-confirm"
                    :disabled="inProgress"
                    @click="saveComment"
                >
                    Guardar
                </button>
            </div>
        </app-pop-up>

        <app-pop-up
            title="Asignación de usuario a la petición"
            id="petition-assignment"
            :on-close="clean"
        >
            <div class="body" slot="body">
                <app-form-select-input
                    label="Seleccione calificación"
                    :options="ratings"
                    v-model="assignation.ratingId"
                    :hasError="$v.assignation.ratingId.$error"
                    errorMessage="Debe seleccionar la calificación"
                    @change="$v.assignation.ratingId.$touch()"
                    :required="true"
                />

                <app-form-select-input
                    label="Seleccione Categoria"
                    :options="categories"
                    v-model="categoryId"
                    @change="
                        !!categoryId
                            ? loadSubCategoriesByCategory(categoryId)
                            : ''
                    "
                />

                <app-form-select-input
                    label="Seleccione sub-categoria"
                    :options="subCategories"
                    v-model="assignation.subcategoryId"
                    :hasError="$v.assignation.subcategoryId.$error"
                    errorMessage="Debe seleccionar la sub-categoria"
                    @change="$v.assignation.subcategoryId.$touch()"
                    :required="true"
                />

                <app-form-select-input
                    label="Seleccione cargo"
                    :options="positions"
                    v-model="positionId"
                    @change="
                        !!positionId ? loadUsersByPosition(positionId) : clean()
                    "
                />
                <app-form-select-input
                    label="Seleccione usuario"
                    :options="users"
                    v-model="assignation.userId"
                    :hasError="$v.assignation.userId.$error"
                    errorMessage="Debe seleccionar el usuario"
                    @change="$v.assignation.userId.$touch()"
                    :required="true"
                />

                <app-date-picker
                    label="Fecha de vencimiento"
                    :with-time="false"
                    v-model="assignation.dueDate"
                    :required="true"
                    :hasError="$v.assignation.dueDate.$error"
                    errorMessage="Debe seleccionar la fecha de vencimiento"
                />
            </div>
            <div slot="buttons">
                <button
                    class="btn btn-confirm"
                    :disabled="inProgress"
                    @click="assignUserToPetition()"
                >
                    Asignar
                </button>
            </div>
        </app-pop-up>

        <app-pop-up id="view-petition-more-unassigned" title="Petición">
            <div slot="body">
                <div class="row">
                    <div class="col-6">
                        <h5>Fecha de creación</h5>
                        <label>{{ petitionView.date | datetime }}</label>
                    </div>
                    <div class="col-6">
                        <h5>Tipo de petición</h5>
                        <label>{{ petitionView.type }}</label>
                    </div>
                    <div class="col-6">
                        <h5>Cliente</h5>
                        <label>{{ petitionView.client }}</label>
                    </div>
                    <div class="col-6">
                        <h5>Usuario</h5>
                        <label>{{ petitionView.user }}</label>
                    </div>
                    <div class="col-6">
                        <h5>Estado</h5>
                        <label>{{ petitionView.status }}</label>
                    </div>
                    <div class="col-6">
                        <h5>Clasificación</h5>
                        <label>{{ petitionView.rating }}</label>
                    </div>
                    <div class="col-6">
                        <h5>Usuarios asignados</h5>
                        <div v-if="petitionView.assignments">
                            <div v-for="assignment in petitionView.assignments">
                                {{
                                    assignment.inactive
                                        ? assignment.user.name
                                        : assignment.user.name +
                                          ' (Actualmente)'
                                }}
                            </div>
                        </div>
                        <div v-if="!petitionView.assignments.length">
                            No tiene
                        </div>
                    </div>
                </div>
                <br />
                <h5 style="text-align:center">
                    <label for="anotation">Descripción</label>
                </h5>
                <textarea
                    type="text"
                    id="anotation"
                    class="form-control"
                    disabled="true"
                    cols="80"
                    rows="8"
                    v-model="petitionView.description"
                ></textarea>
            </div>
        </app-pop-up>

        <!-- fin de pop ups -->
    </div>
</template>
<script>
import petitionsRepository from '../../../repositories/petitions.repository.js'
import userRepository from '../../../repositories/users.repository.js'
import AddPetitionComment from '../PetitionComment/AddPetitionComment.vue'
import { required } from 'vuelidate/lib/validators'
import DatePicker from '../../UI/Controls/DateTimePicker/DateTimePicker.vue'
import PqrForm from '../../AdminClients/Pqr/PqrForm.vue'
import { mapGetters } from 'vuex'
import TableUnassignedPetitions from './TableUnassignedPetitions/TableUnassignedPetitions.vue'
import PetitionFilters from '../PetitionFilters/PetitionFilters.vue'
import PetitionCommentsList from '../PetitionComment/PetitionCommentsList'
export default {
    components: {
        appAddPetitionComment: AddPetitionComment,
        appDatePicker: DatePicker,
        appPqrForm: PqrForm,
        appTableUnassignedPetitions: TableUnassignedPetitions,
        appPetitionFilters: PetitionFilters,
        appPetitionCommentsList: PetitionCommentsList,
    },

    data() {
        return {
            categories: [],
            subCategories: [],
            ratings: [],
            clientId: '',
            petitionView: {
                user: '',
                client: '',
                type: '',
                date: '',
                description: '',
                status: '',
                rating: '',
                assignments: [],
            },
            commentsPetitionSelect: [],
            data: {},
            assignation: {
                userId: '',
                petitionId: '',
                assignedBy: '',
                dueDate: null,
                subcategoryId: '',
                ratingId: '',
            },
            categoryId: '',
            petitionComment: {},
            users: [],
            positionId: '',
            filters: {},
            page: 1,
            sort: {
                sortBy: 'created_at',
                sortDir: 'desc',
            },
        }
    },

    validations: {
        assignation: {
            userId: { required },
            petitionId: { required },
            dueDate: { required },
            subcategoryId: { required },
            ratingId: { required },
        },
    },
    computed: {
        ...mapGetters(['positions', 'clients']),
    },
    methods: {
        loadPetitionCategories() {
            const pr = Object.assign({}, petitionsRepository)
            pr.loadPetitionCategories()
                .then(data => (this.categories = data))
                .catch(error =>
                    this.toastr.error('Error al cargar las categorias')
                )
        },
        loadSubCategoriesByCategory(categoryId) {
            this.assignation.subcategoryId = ''
            this.$v.$reset()
            const pr = Object.assign({}, petitionsRepository)
            pr.loadSubCategoriesByCategory(categoryId)
                .then(data => {
                    this.subCategories = data
                    if (this.subCategories.length == 1) {
                        this.assignation.subcategoryId = this.subCategories[0].id
                    }
                })
                .catch(error =>
                    this.toastr.error('Error al cargar las categorias')
                )
        },
        loadPetitionRatings() {
            const pr = Object.assign({}, petitionsRepository)
            pr.loadPetitionRatings()
                .then(data => (this.ratings = data))
                .catch(() =>
                    toastr.error('Error al cargar las calificaciones')
                )
        },
        loadPetitions() {
            const filters = {
                ...this.filters,
                sortBy: this.sort.sortBy,
                sortDir: this.sort.sortDir,
            }
            const pr = Object.assign({}, petitionsRepository)

            pr.loadPetitionsNotAssigned(filters, this.page)
                .then(data => {
                    this.data = data
                })
                .catch(error =>
                    toastr.error('Error al cargar las peticiones pendientes')
                )
        },
        deletePetition(petition) {
            const pr = Object.assign({}, petitionsRepository)
            pr.deletePetition(petition.id)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg)
                        this.loadPetitions()
                        this.$bus.$emit('loadNotifications')
                    } else {
                        toastr.warning(data.msg)
                    }
                })
                .catch(err => {
                    const msg =
                        err.response &&
                        err.response.data &&
                        err.response.data.msg
                    toastr.error(
                        msg || 'No fue posible eliminar la petición'
                    )
                })
        },
        onChangePage(page) {
            this.page = page
            this.loadPetitions()
        },
        loadUsersByPosition(positionId) {
            this.assignation.userId = ''
            this.$v.$reset()
            const ur = Object.assign({}, userRepository)
            ur.loadUsersByPosition(positionId)
                .then(data => {
                    this.users = data
                    if (this.users.length == 1) {
                        this.assignation.userId = this.users[0].id
                    }
                })
                .catch(error => {
                    toastr.error('Error al cargar los usuarios de este cargo')
                })
        },
        seeMore(petition) {
            Object.keys(this.petitionView).map(
                key => (this.petitionView[key] = '')
            )
            this.petitionView.user = petition.user.name
            this.petitionView.client = petition.client.name
            this.petitionView.type = petition.petition_type.name
            this.petitionView.date = petition.created_at
            this.petitionView.description = petition.description
            this.petitionView.status = petition.petition_status.name
            this.petitionView.rating = petition.petition_rating
                ? petition.petition_rating.name
                : 'Sin clasificación'
            this.petitionView.assignments = petition.petition_assignment

            this.$bus.$emit('view-petition-more-unassigned.open')
        },
        seeCommentsByPetition(petition) {
            this.commentsPetitionSelect = petition.comments
            this.$bus.$emit('view-comments-petition-unassigned.open')
        },
        startAssignUserToPetition(petition) {
            this.assignation.dueDate = petition.due_date
            this.assignation.petitionId = petition.id
            this.$bus.$emit('petition-assignment.open')
        },
        clean() {
            this.users = []
            this.subCategories = []
            this.positionId = ''
            this.categoryId = ''
            this.assignation.userId = ''
            this.assignation.subcategoryId = ''
            this.assignation.ratingId = ''
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },
        assignUserToPetition() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                toastr.error(
                    'Debe diligenciar correctamente todos los campos obligatorios'
                )
                return false
            }

            this.assignation.assignedBy = this.user.id
            const pr = Object.assign({}, petitionsRepository)
            pr.saveAssignation(this.assignation)
                .then(data => {
                    if (data.status) {
                        this.clean()
                        this.assignation.petitionId = ''
                        this.loadPetitions()
                        this.$bus.$emit('petition-assignment.close')
                        toastr.success(data.msg)
                    } else {
                        toastr.warning(data.msg)
                    }
                })
                .catch(error => {
                    toastr.error('Error al asignar usuario')
                })
        },
        startAddComment(petition) {
            this.petitionComment = petition
            this.$bus.$emit('petition-comment-unassigned.open')
        },
        saveComment() {
            this.$bus.$emit('petition-comment-unassigned.save')
        },
        onSaveComment() {
            this.$bus.$emit('petition-comment-unassigned.close')
            this.loadPetitions()
        },
        cleanFormComment() {
            this.$bus.$emit('petition-comment-unassigned.clean')
        },
        onSave() {
            this.$bus.$emit('petition-form.close')
            this.$nextTick(() => {
                this.$v.$reset()
            })
            this.loadPetitions()
        },
        cleanPqrForm() {
            this.clientId = ''
            this.$bus.$emit('petition-form.clean')
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy
            this.sort.sortDir = ctx.sortDir
            this.loadPetitions()
        },
        onFilter(filters) {
            this.filters = filters
            this.loadPetitions()
        },
        onRemoveComment() {
            if (!this.commentsPetitionSelect.length) {
                this.$bus.$emit('view-comments-petition-unassigned.close')
            }
        },
    },

    created() {
        this.loadPetitions()
        this.load('clients')
        this.load('positions')
        this.loadPetitionCategories()
        this.loadPetitionRatings()
    },
}
</script>
<style>
.client-selector-section {
    flex: 0 0 65%;
}
.button-section {
    flex: 0 0 30%;
}
</style>
